var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExtrinsicSuccess = function SvgExtrinsicSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.001,
    cy: 12,
    r: 12,
    fill: "#0E2C1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#46DA93",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96,
    d: "m7.2 12.847 2.541 2.824 7.06-7.342"
  })));
};
export default SvgExtrinsicSuccess;